import type { EtatMouvement, TypeMouvement } from '@artosera/shared';
import type { BadgeTone } from '@artosera/ui';
export const TON_ETAT: Record<EtatMouvement, BadgeTone> = {
  prevu: 'neutral',
  en_cours: 'deposit',
  termine: 'available',
  annule: 'withdrawn',
};
export const cleTypeMouvement = (type: TypeMouvement) => `regie:mouvements.types.${type}` as const;
